<template>
  <empty-state class="margin-auto mt-12">
    <template #icon>
      <v-icon size="80" icon="$backupAndRestoreL" />
    </template>
    <template #description>
      <span>{{ $t("cloudBackupAndRestore.parentNotActivated.title") }}</span>
    </template>
    <template #subtitle>
      <span data-testid="backup-and-restore-parent-not-activated-subtitle">
        {{ $t("cloudBackupAndRestore.parentNotActivated.subtitle", { parentWorkspaceId }) }}
      </span>
    </template>
  </empty-state>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import EmptyState from "@/components/EmptyState.vue";

export default defineComponent({
  components: {
    EmptyState,
  },
  props: {
    parentWorkspaceId: {
      type: String,
      default: "",
    },
  },
});
</script>

<style lang="scss" scoped></style>
